"use client";

import HeroSection from "@/components/layout/HeroSection";

/**
 * Wrapper component for HeroSection that allows custom tool widgets
 * without modifying the battle-tested homepage HeroSection component.
 * 
 * This wrapper provides a safe way to inject custom oracle tool components
 * into the hero section while keeping the homepage code untouched.
 * 
 * @param {Object} props - Component props
 * @param {React.Component} props.customWidget - Custom widget component to render instead of YesNoOracleWidget
 */
export default function ToolHeroSection(props) {
  const { customWidget, toolConfig, content, ...heroProps } = props;
  
  // Extract API endpoints from toolConfig if provided
  const apiEndpoint = toolConfig?.apiEndpoint || '/api/oracle/yes-no';
  const usageApiEndpoint = toolConfig?.usageApiEndpoint || '/api/usage/free-yesno';
  
  // Extract widget titles from content (for custom tools like pendulum)
  const widgetTitleFree = content?.widgetTitle?.free || null;
  const widgetTitlePremium = content?.widgetTitle?.premium || null;
  
  // If custom widget provided, pass it to HeroSection
  // HeroSection will use it instead of default YesNoOracleWidget
  if (customWidget) {
    return (
      <HeroSection
        {...heroProps}
        content={content}
        customWidget={customWidget}
        apiEndpoint={apiEndpoint}
        usageApiEndpoint={usageApiEndpoint}
        widgetTitleFree={widgetTitleFree}
        widgetTitlePremium={widgetTitlePremium}
      />
    );
  }

  // Default behavior (same as homepage - uses YesNoOracleWidget)
  return <HeroSection {...heroProps} content={content} apiEndpoint={apiEndpoint} usageApiEndpoint={usageApiEndpoint} />;
}

